import React, { Component } from 'react';
import PageTitle from '../home/PageTitle';
import LocalStorageHelper from '../../LocalStorageHelper/LocalStorageHelper';
import AgGridComponent from '../common/AgGridComponent';
import PaginationComponent, { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from '../common/PaginationComponent';
import { createMasterActionColumn, createMasterActiveColumn } from '../../utils/masterGridHelpers';
import {
    buildMasterGridParams,
    ADDITIONAL_CHARGE_SORT_WHITELIST,
    ADDITIONAL_CHARGE_FILTER_WHITELIST,
} from '../../utils/agGridServerHelpers';
import ApiURL from '../../api/ApiURL';
import cogoToast from 'cogo-toast';
import axios from 'axios';

class AdditionalCharge extends Component {
    //constructor lifecycle event
    constructor(props) {
        super(props);
        ////register Handsontable's modules
        //registerAllModules();
        this.state = {
            showModal: false,
            showDeleteWarnModal: false,
            additionalChargeData: [],
            isTableLoading: true,
            currentPage: 1,
            pageSize: DEFAULT_PAGE_SIZE,
            totalRecords: 0,
            columnDefs: [],
            sortModel: [],
            filterModel: {},
            chargeId: 0,
            chargeDescription: '',
            userId: 0,
            userRole: '',
            isActive: true
        };
    }
    //componentDidMount lifecycle event
    componentDidMount() {
        window.scroll(0, 0);
        var userData = JSON.parse(LocalStorageHelper.getUser());
        if (userData !== null && userData.UserId > 0) {
            this.setState({
                userId: userData.UserId,
                userRole: userData.RoleName,
                displayName: userData.DisplayName
            })
        }
        this.getAllAdditionalChargeData();
        this.getAllDataColumns();
    }
    //Data Reload
    handleReload = () => this.setState({ currentPage: 1 }, this.getAllAdditionalChargeData);
    handleSortChange = (sortModel) => {
        this.setState({ sortModel, currentPage: 1 }, this.getAllAdditionalChargeData);
    };
    handleFilterChange = (filterModel) => {
        this.setState({ filterModel, currentPage: 1 }, this.getAllAdditionalChargeData);
    };
    handlePageChange = (page) => {
        this.setState({ currentPage: page }, this.getAllAdditionalChargeData);
    };
    handlePageSizeChange = (size) => {
        this.setState({ pageSize: size, currentPage: 1 }, this.getAllAdditionalChargeData);
    };
    //Reset all input fields into the modal
    resetInputFields = () => {
        this.setState({
            showModal: false,
            showDeleteWarnModal: false,
            chargeId: 0,
            chargeDescription: '',
            isActive: true
        });
    }
    //Open modal
    openModal = () => this.setState({ showModal: true });
    //Close modal
    closeModal = () => this.setState({ showModal: false });
    //Open Delete warning modal
    openWarnModal = () => this.setState({ showDeleteWarnModal: true });
    //Close Delete warning modal
    closeWarnModal = () => this.setState({ showDeleteWarnModal: false });
    //OnChangeHandler
    handleChange = (e) => {
        //console.log(e.target.checked);
        if (e.target.name === 'isActive') {
            this.setState({ [e.target.name]: e.target.checked });
        }
        else {
            this.setState({ [e.target.name]: e.target.value });
        }
    }
    //Get all Charge data
    getAllAdditionalChargeData = () => {
        const { currentPage, pageSize, sortModel, filterModel } = this.state;
        const param = buildMasterGridParams(
            currentPage,
            pageSize,
            sortModel,
            filterModel,
            ADDITIONAL_CHARGE_SORT_WHITELIST,
            ADDITIONAL_CHARGE_FILTER_WHITELIST
        );
        this.setState({ isTableLoading: true });
        axios
            .post(ApiURL.GetAllAdditionalCharge, param)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({
                        additionalChargeData: dataResult.AdditionalCharges,
                        totalRecords: dataResult?.TotalRecords ?? 0,
                    });
                } else if (respData.StatusCode === 404) {
                    this.setState({ additionalChargeData: [], totalRecords: 0 });
                } else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            })
            .finally(() => {
                this.setState({ isTableLoading: false });
            });
    }
    //Get all columns
    getAllDataColumns = () => {
        this.setState({
            columnDefs: [
                createMasterActionColumn(this.getDataItemById, "ChargeId"),
                { headerName: "Charge Description", field: "ChargeDescription", flex: 1, minWidth: 160, cellClass: "text-left" },
                createMasterActiveColumn(),
            ],
        })
    }
    //Get data by Id
    getDataItemById = (keyData) => {
        var self = this;
        axios
            .get(ApiURL.GetAdditionalCharge(keyData))
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    console.log(dataResult);
                    self.setState({
                        chargeId: dataResult.ChargeId,
                        chargeDescription: dataResult.ChargeDescription,
                        isActive: dataResult.IsActive,
                        showModal: true,
                    });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Handle Add new Record
    handleAddNew = () => {
        this.resetInputFields();
        this.openModal();
    }
    //Delete data by Id
    handleDelete = () => {
        let param = {
            ChargeId: this.state.chargeId,
            ChargeDescription: this.state.chargeDescription,
            UserId: this.state.userId,
            IsActive: false
        };
        axios.post(ApiURL.SaveAdditionalCharge, param)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    cogoToast.success("Additional Charge deleted successfully!", { position: "bottom-center" });
                    this.resetInputFields();
                    this.closeWarnModal();
                    this.getAllAdditionalChargeData();
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //save data
    handleSubmit = (e) => {
        e.preventDefault();
        const { chargeId, chargeDescription, userId, isActive } = this.state;        
        if (chargeDescription === '') {
            cogoToast.error("Charge Description is required", { position: "bottom-center" });
        }
        else {
            let param = {
                ChargeId: chargeId,
                ChargeDescription: chargeDescription,
                UserId: userId,
                isActive: isActive
            };
            console.log(param);
            axios
                .post(ApiURL.SaveAdditionalCharge, param)
                .then((response) => {
                    let respData = response.data;
                    if (respData.StatusCode === 200) {
                        cogoToast.success("Additional Charge saved successfully!", { position: "bottom-center" });
                        this.resetInputFields();
                        this.getAllAdditionalChargeData();
                    }
                    else if (respData.StatusCode === 500) {
                        cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                    }
                })
                .catch((error) => {
                    cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
                });
        }
    }

    render() {
        const { additionalChargeData, showModal, showDeleteWarnModal, columnDefs, chargeId, chargeDescription, isActive,
            currentPage, pageSize, totalRecords } = this.state;
        const isAdmin = this.state.userRole === 'admin';
        const isEnabled = isAdmin && isActive && chargeId > 0;

        return (
            <>
                <div className="master-page">
                <div className="container-fluid bg-primary-subtle border-bottom border-primary top-action-bar">
                    <div className="card bg-primary-subtle flex-row py-1 mb-0 mx-2">
                        <div className="col-md-9 justify-content-start">
                            <PageTitle Title="Manage Additional Charge" />
                        </div>
                        <div className="col-md-3 text-right pt-1">
                            <button className="btn btn-outline-dark btn-sm px-3 mx-3" title="Refresh" onClick={this.handleReload}>
                                <i className="fa-solid fa-arrows-rotate"></i> Refresh
                            </button>
                            <button className="btn btn-outline-primary btn-sm px-3 cursor-pointer" title="Add" onClick={this.handleAddNew}>
                                <i className="fa-solid fa-plus"></i> Add
                            </button>
                        </div>
                    </div>
                </div>
                <div className="master-page__body">
                    <PaginationComponent
                        currentPage={currentPage}
                        totalPages={Math.ceil(totalRecords / pageSize) || 1}
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        pageSizeOptions={DEFAULT_PAGE_SIZE_OPTIONS}
                        onPageChange={this.handlePageChange}
                        onPageSizeChange={this.handlePageSizeChange}
                    />
                    <div className="master-page__grid">
                        <AgGridComponent
                            columnDefs={columnDefs}
                            rowData={additionalChargeData}
                            isLoading={this.state.isTableLoading}
                            onSortChange={this.handleSortChange}
                            onFilterChange={this.handleFilterChange}
                            fillHeight
                        />
                    </div>
                </div>
                </div>

                {/* <!----------------- modal section----------------> */}
                <div className={showModal === true ? "modal show-modal  modalWrapper" : "modal"} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title ">{chargeId <= 0 ? `Add Additional Charge` : `Update Additional Charge`}</h1>
                                <i className="fa-regular fa-circle-xmark text-danger" data-bs-dismiss="modal" onClick={this.closeModal}></i>
                            </div>
                            <div className="modal-body">
                                <div className="row">                                    
                                    <div className="col-md-12 mb-2">
                                        <label className="form-label text-sm">Charge Description *</label>
                                        <input type="text"
                                            className="form-control-sm border border-primary w-100"
                                            name="chargeDescription"
                                            value={chargeDescription}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    {/* <div className="col-md-6 mb-2">
                                        <label className="form-label text-sm">Active Status</label>
                                        <input type="checkbox"
                                            className="form-control-sm border border-primary w-100"
                                            name="isActive"
                                            checked={isActive}
                                            onChange={this.handleChange}
                                        />
                                    </div> */}
                                </div>
                            </div>
                            <div className="modal-footer my-3">
                                <button
                                    type="submit"
                                    className="btn btn-success button-box-shadow"
                                    onClick={this.handleSubmit}
                                >
                                    <i className="fa-regular fa-floppy-disk"></i> Save
                                </button>
                                < button
                                    type="button"
                                    className={`btn btn-danger button-box-shadow curser-pointer ${isEnabled ? '' : 'disabled'}`}
                                    onClick={() => { isEnabled && this.openWarnModal() }}
                                >
                                    <i className="fa-solid fa-trash-can"></i> Delete
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary button-box-shadow"
                                    data-bs-dismiss="modal"
                                    onClick={this.closeModal}
                                >
                                    <i className="fa-solid fa-circle-xmark"></i> Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div >

                {/* <!------DELETE Warning Modal--------> */}
                <div className={showDeleteWarnModal === true ? "modal show-modal" : "modal"}>
                    <div className="modal-dialog modal-dialog-centered modal-md ">
                        <div className="modal-content button-box-shadow">
                            <div className="modal-body">
                                <div className="alert alert-warning d-flex align-items-center" role="alert" >
                                    <i className="fa-solid fa-triangle-exclamation"></i>&nbsp;
                                    <div><strong>Are you sure</strong>, you want to <strong>Delete </strong> it?</div>
                                </div>
                            </div>
                            <div className="modal-footer ">
                                <button
                                    type="button"
                                    className="btn btn-danger button-box-shadow btn-sm"
                                    onClick={this.handleDelete}
                                >
                                    <i className="fa-solid fa-trash-can"></i> Delete
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-secondary button-box-shadow btn-sm"
                                    data-bs-dismiss="modal"
                                    onClick={this.closeWarnModal}
                                >
                                    <i className="fa-solid fa-circle-xmark"></i> Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div >

            </>
        );
    }
}

export default AdditionalCharge;